import React from "react";
import { ModalPopup } from "wbm-generic-components";

export interface IProductAvailabilityPopupProps {
  setShow: boolean;
  onClose?: () => void;
}

export const ProductAvailabilityPopup: React.FC<IProductAvailabilityPopupProps> = (
  props: IProductAvailabilityPopupProps
) => {
  return (
    <ModalPopup
      header="Not Available In Your Area"
      boxShadow
      setShow={props.setShow}
      className="prevent-purchase-modal"
      actionItem={props.onClose}
      actionItemText="OK"
      actionItems
      disableBackdropClick={true}
      onClose={props.onClose}
    >
      <div>
        We&apos;re sorry, this product is not available for your selected
        shipping address. It cannot be added to your cart.
      </div>
    </ModalPopup>
  );
};

export default ProductAvailabilityPopup;
